var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRegion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-region",
    transform: "translate(12009 13006)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_320",
    "data-name": "Rectangle 320",
    width: 24,
    height: 24,
    transform: "translate(-12009 -13006)",
    fill: "#3770fb",
    opacity: 0.002
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6031",
    "data-name": "Path 6031",
    d: "M2,4H8V6h8V4h6v6H20v4h2v6H16V18H8v2H2V14H4V10H2V4m14,6V8H8v2H6v4H8v2h8V14h2V10H16M4,6V8H6V6H4M18,6V8h2V6H18M4,16v2H6V16H4m14,0v2h2V16Z",
    transform: "translate(-12009 -13006)",
    fill: "#2a3072"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRegion);
export default __webpack_public_path__ + "static/media/icon-region.e74ee15431a07bbbb64182af7e6e95f1.svg";
export { ForwardRef as ReactComponent };